namespace SPA {
	export namespace Realtor2 {

		export interface INewDisposalObject {
			object: IDisposalObject;
			property: IProperty;
			common: IObjectCommon;
			details: IObjectDetails;
			modernization: IModernization;
			benefits: {};
			general: IFinal;
		}

		export class NewDisposalObject extends ui.tab.TabHTMLPresentation {

			private m_Guide: SPA.Guide.GuideRoot;
			private m_Data: INewDisposalObject;
			private ViewMode: 'view' | 'new';

			private m_Order: IOrder;

			public constructor(private m_Company: Wollmilch.CompanyObject, object: any = null, viewMode: 'view' | 'new' = 'new') {
				super();

				this.ViewMode = viewMode;
				this.m_Guide = new SPA.Guide.GuideRoot();
				this.m_Data = NewDisposalObject.getDefaults();

				if (this.ViewMode === 'view') {
					// Todo Find a better solution
					// Empty array to object conversion
					if (object.length === 0) {
						object = {};
					}

					const newData = deepmerge(this.m_Data, object, {});
					this.m_Data = newData;
				}

				this.m_Order =
					{
						lrm: false,
						register:
							{
								order: false,
								file: null
							},
						easement:
							{
								order: false,
								file: null
							},
						datapackage: false,
						assessment:
							{
								immowertv: true,
								belwertv: true,
								belwertv_bafin: true
							}
					};
			}

			public setLRM(lrm: boolean): void {
				this.m_Order.lrm = lrm;
			}

			public setDataPackage(dp: boolean): void {
				this.m_Order.datapackage = dp;
			}

			public setRegister(register: IOrderWithFile): void {
				this.m_Order.register = register;
			}

			public setEasement(easement: IOrderWithFile): void {
				this.m_Order.easement = easement;
			}

			public getLRM(): boolean {
				return this.m_Order.lrm;
			}

			public getDataPackage(): boolean {
				return this.m_Order.datapackage;
			}

			public getRegister(): IOrderWithFile {
				return this.m_Order.register;
			}

			public getEasement(): IOrderWithFile {
				return this.m_Order.easement;
			}

			public sendForm(): void {
				console.log(this.m_Order);
				console.log(this.m_Data);
				new Wollmilch.AJAX(
					{
						method: 'POST',
						url: 'object/new',
						data: Object.assign(
							{
								orders: this.m_Order
							},
							this.m_Data
						),
						on:
							{
								success: (text: string) => {
									const _json = Wollmilch.jsonize(text);
									if (_json === null || !_json.success) {
										app.addNotify(
											{
												body: [
													'Das Anlegen des Objektes ist fehlgeschlagen.'
												],
												context: 'danger',
												title: ['Anlegen fehlgeschlagen'],
												timeout: Number(app.getConfigValue("ToastTimeout"))
											}
										);

										return;
									}
									// Shows the Modal Box on Success
									const modalBox: ui.dialog.Modal = new ui.dialog.Modal({
										// head: [ui.$$.div().addClass('text-success').append('<h2>Header</h2>')],
										body: [ui.$$.div().addClass('').append('<h4>Das Objekt wurde erfolgreich angelegt.</h4>')],
										foot: [ui.$$.button()
											.text("OK")
											.attr({
												type: 'button'
											})
											.addClass('btn btn-primary')
											.on('click', () => {
												modalBox.Hide();
												// Todo F5, workaround for now
												location.reload();
											})
										],
										backdrop: true,
										noCloseBtn: true
									});
									new Wollmilch.AJAX({
										method: 'POST',
										url: 'object/mikromakro',
										data: _json.data,
									}, Wollmilch.AJAXCallbase_e.REALTOR).send();

									app.getObjectManager().addItem(_json.data);

									app.getGlobalTabControl().removeTab(this.m_Entry);
									return;
								}
							}
					},
					Wollmilch.AJAXCallbase_e.REALTOR
				).send();
			}

			public checkForm(_form: ui.Form.Form, _timeout: number = 5000): boolean {
				if (_form.isValid({}, [])) {
					return true;
				}

				app.addNotify(
					{
						title: ['Formularangaben unvollständig/inkorrekt'],
						body: ['Bitte überprüfen Sie Ihre Formularangaben und korrigieren/vervollständigen Sie diese bitte.'],
						context: 'warning',
						timeout: _timeout
					}
				);

				return false;
			}

			public rebuild(root: ui.base.BaseHTMLElement): NewDisposalObject {
				this.empty();
				this.remove();

				this.appendTo(new ui.Box.Box().appendTo(root));

				this.buildGuide();
				this.m_Guide.rebuild(this);

				return this;
			}

			private buildGuide(): void {
				let label = 1;

				if (this.ViewMode === 'new') {
					this.m_Guide.addItem(
						new SPA.Guide.GuideItem(
							{
								label: label.toString(),
								border: {
									color: '#535353',
									radius: '50%',
									style: 'solid',
									width: '2px'
								},
								description: 'Allg. Angaben'
							},
							new New.Common(this.m_Company, this.m_Data.object, this),
							false
						)
					);
					label++;
				}

				this.m_Guide.addItem(
					new SPA.Guide.GuideItem(
						{
							label: label.toString(),
							border: {
								color: '#535353',
								radius: '50%',
								style: 'solid',
								width: '2px'
							},
							description: 'Grundstück'
						},
						new New.Property(this.m_Data, this),
						false
					)
				);
				label++;

				this.m_Guide.addItem(
					new SPA.Guide.GuideItem(
						{
							label: label.toString(),
							border: {
								color: '#535353',
								radius: '50%',
								style: 'solid',
								width: '2px'
							},
							description: 'Objektart'
						},
						new New.ObjectCommon(this.m_Data.common, this),
						false
					)
				);
				label++;

				this.m_Guide.addItem(
					new SPA.Guide.GuideItem(
						{
							label: label.toString(),
							border: {
								color: '#535353',
								radius: '50%',
								style: 'solid',
								width: '2px'
							},
							description: 'Objektdetails'
						},
						new New.ObjectDetails(this.m_Data.details, this),
						false
					)
				);
				label++;

				this.m_Guide.addItem(
					new SPA.Guide.GuideItem(
						{
							label: label.toString(),
							border: {
								color: '#535353',
								radius: '50%',
								style: 'solid',
								width: '2px'
							},
							description: 'Modernisierung'
						},
						new New.Modernization(this.m_Data.modernization, this),
						false
					)
				);
				label++;
				/*
								this.m_Guide.addItem(
									new SPA.Guide.GuideItem(
										{
											label: '6',
											border: {
												color: '#535353',
												radius: '50%',
												style: 'solid',
												width: '2px'
											},
											description: 'Erträge'
										},
										new New.Benefit(),
										false,
										this
									)
								);
				*/

				this.m_Guide.addItem(
					new SPA.Guide.GuideItem(
						{
							label: label.toString(),
							border: {
								color: '#535353',
								radius: '50%',
								style: 'solid',
								width: '2px'
							},
							description: 'Abschluss',
						},
						new New.Final(this.m_Data.general, this.m_Company, this),
						false
					)
				);
			}

			public static getDefaults(): INewDisposalObject {
				const defaults: INewDisposalObject = {
					object:
						{
							project: 'disposal',
							address:
								{
									street: '',
									housenumber: '',
									postalcode: '',
									city: '',
									state: '',
									country: 'DE',
									ags: '',
								},
							quality:
								{
									micro: -1,
									macro: -1,
									annotation: ''
								},
							seller:
								{
									id: null,
								},
							owner:
								{
									id: null,
								}
						},
					property:
						{
							area:
								{
									building: 0,
									garden: 0
								},
							leasehold:
								{
									present: false,
									residual_time: 0,
									ground_rent: 0,
									compensation: 0,
									disadvantage: 0,
									rate: 0,
									annotation: ''
								},
							structural:
								{
									path: null,
									layout:
										{
											value: null,
											corner: false,
											pipe: false,
											slope: false,
											towel: false
										},
									garden: null,
									courtyard: null,
									enclosure: null,
									annotation: ''
								},
							register:
								{
									registry_deeds: '',
									court: '',
									volume: '',
									page: '',
									list: [],
									active_annotation: '',
									annotation: ''
								},
							easements: {
								value: 'NOTHING',
								annotation: ''
							},
							preload: [],
							annotation: ''
						},
					common:
						{
							type: null,
							heating:
								{
									type:
										{
											central: false,
											per_floor: false,
											per_unit: false
										},
									features:
										{
											gas: false,
											oil: false,
											electricity: false,
											pellet: false,
											plant_oil: false,
											geothermal_pump: false,
											air_heat_exchanger: false,
											coal: false,
											biomass: false,
											radiation: false,
											solar: false,
											district: false,
											log_man: false,
											log_auto: false,
											floor_heating: false,
											heater: false
										}
								},
							annotation: ''
						},
					details:
						{
							object:
								{
									construction_year: 0,
									lettability: 'SATISFYING',
									usability: 'SATISFYING',
									use_capability: true,
									annotation: ''
								},
							living_area:
								{
									type: 'NGF',
									value: 0
								},
							outdoor_facilities:
								{
									type: 'RELATIVE',
									value: 5
								},
							parking: []
						},
					modernization:
						{
							object_condition:
								{
									value: 'SATISFYING',
									annotation: ''
								},
							redevelopment:
								{
									redeveloped: false,
									windows:
										{
											value: null,
											year: null
										},
									electricity:
										{
											value: null,
											year: null
										},
									gas:
										{
											value: null,
											year: null
										},
									water:
										{
											value: null,
											year: null
										},
									sewage:
										{
											value: null,
											year: null
										},
									heating_system:
										{
											value: null,
											year: null
										},
									sanitary:
										{
											value: null,
											year: null
										},
									interior:
										{
											value: null,
											year: null
										},
									roof:
										{
											value: null,
											year: 0
										},
									outdoor_walls:
										{
											value: null,
											year: 0
										},
									floor_plan:
										{
											value: null,
											year: 0
										},
									annotation: ''
								},
							additional:
								{
									value_depressing:
										{
											flaws: null,
											maintenance_backlog: null,
											other: null,
											annotation: ''
										},
									value_improving:
										{
											value: null,
											annotation: ''
										}
								},
							annotation: ''
						},
					benefits: {},
					general:
						{
							price:
								{
									value: 0,
									currency: 'EUR'
								},
							yearlyRent:
								{
									value: 0,
									currency: 'EUR',
								},
							fee:
								{
									interior: null,
									exterior: null
								},
							soulmandate_from: '',
							soulmandate_to: '',
							order_until:
								{
									value: null,
									format: 'd.m.Y'
								},
							title: '',
							annotation: '',
							ref: ''
						}
				};

				return defaults;
			}

		}
	}
}
